import React from 'react';
import { Link } from 'react-router-dom';
// import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as specialistActions from '../../actions/specialistActions';
import Pagination from "react-js-pagination";
import * as SVGICONS from '../../images/img/images';
import Moment from 'react-moment';
import StarRatingComponent from 'react-star-rating-component';
import * as constant from '../../constants/constant';
import FeedbackDetail from './feedbackDetail';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import $ from "jquery";
import * as dashboardActions from "../../actions/dashboardActions";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
const size = 10;
const styleIcon = {
	paddingRight: 10,
	cursor: 'pointer'
}
class MyFeedback extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			myFeedback: [],
			activePage: 1,
			count: size,
			totalCount: size,
			sortColumnName: '',
			sortOrder: -1,
			//feedack detail
			isRateModalOpen: false,
			patientId: '',
			appointmentId: '',
			patientDetail: {},
			appointmentDate: '',
			appointmentTime: '',
			avgRate: 0,
			logoutButton: false
		}
		this.handlePageChange = this.handlePageChange.bind(this);
		this._sortClass = this._sortClass.bind(this);
		this.sortChanged = this.sortChanged.bind(this);
		this.OpenRateDetail = this.OpenRateDetail.bind(this);
		this.closeRateModal = this.closeRateModal.bind(this);
		this.closeRateModalNCallList = this.closeRateModalNCallList.bind(this);
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this)

		this._logout = this._logout.bind(this)
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);

	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle() {
		var windowWidth = $(window).width();
		if (windowWidth < 768) {
			$("body").toggleClass("sidebar-open");
		} else {
			$("body").toggleClass("sidebar-collapse");
		}
	}
	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		var obj = {
			doctorId: localStorage.getItem('userId'),
			count: this.state.count,
			page: pageNumber
		}
		this.props.actions.getMyFeedback(obj);
	}

	componentWillMount() {


		var obj = {
			doctorId: localStorage.getItem('userId'),
			count: this.state.count,
			page: this.state.activePage
		}
		this.props.actions.getMyFeedback(obj);
	}

	componentWillReceiveProps(nextProps) {
		// debugger;
		var state = this.state;
		if (nextProps.myFeedback.ratingDetails) {
			state.myFeedback = nextProps.myFeedback.ratingDetails,
				state.totalCount = nextProps.myFeedback.totalCount,
				this.setState(state);
		}

	}

	//function for sorting
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;

		var obj = {
			doctorId: localStorage.getItem('userId'),
			count: this.state.count,
			page: this.state.activePage,
			sorting: sorting
		}
		this.props.actions.getMyFeedback(obj);
	}

	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	OpenRateDetail(item) {
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className='custom-ui disclaimer_appointement'>
						<a style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>

						<h1>Disclaimer</h1>
						{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
						<span>Your feedback should not identify or make reference to any individual, living or otherwise, in any way, whether in a positive or negative light.  You must also be objective in your feedback, with an emphasis on tangible actions recorded in your feedback post.  The aim of the feedback mechanism is to guide other prospective patients, any official or unofficial complaints should be followed up with Medfix Support Team.  All posts are moderated before being published and may be declined or withdrawn at any time.  Your use of the feedback system constitutes acceptance of the Medfix Terms and Conditions.</span>
						<div className="bottomBtn text-center"><button type="button" onClick={() => {
							var state = this.state;
							state.isRateModalOpen = true;
							state.appointmentId = item.appointmentId;
							state.patientId = item.patientId;
							state.patientDetail = item.patientDetail ? item.patientDetail[0] : {};
							state.appointmentDate = item.appointmentDate;
							state.appointmentTime = item.appointmentTime;
							state.avgRate = item.avgRate;
							this.setState(state);
							onClose()
						}} className="btn btn-warning btn-lg">Ok</button></div>
					</div>
				)
			}
		})



		// this.props.history.push('/specialist/feedback-response/' + item.appointmentId + "/" + item.patientId)
	}
	closeRateModal() {
		this.setState({ isRateModalOpen: false })

	}
	closeRateModalNCallList() {
		var state = this.state;
		state.isRateModalOpen = false;
		this.setState(state);
		// var obj = {
		// 	doctorId: localStorage.getItem('userId'),
		// 	count: this.state.count,
		// 	page: this.state.activePage
		// }
		// this.props.actions.getMyFeedback(obj);
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}

	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}
	render() {
		// var defaultImagePath = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png'
			}
			else {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png'
			}
			// var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var rows = [];
		var myFeedback = [];
		myFeedback = this.state.myFeedback ? this.state.myFeedback : [];
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2');
		var userType = localStorage.getItem('userType');
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						
				<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
				<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper" >
					<section className="content container-fluid">
						<ToastContainer />
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li><Link href="#tab_1" className="active show" data-toggle="tab" > Feedback Listing</Link></li>
										</ul>
										<div className="tab-content" style={{ "minHeight": 410 }}>
											<div className="tab-pane active" id="tab_1">
												<div id="cbp-vm" className="cbp-vm-switcher cbp-vm-view-grid">
													<div className="cbp-vm-options">

													</div>

													<div className="table-responsive">
														<table className="table table-striped table-bordered table-hover">
															<thead>
																<tr>
																	<th>

																	</th>
																	<th onClick={this.sortChanged.bind(this, 'encryptedUserName', this.state.sortOrder)}>
																		Patient Name
																	<i className={this._sortClass('username')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'appointmentDate', this.state.sortOrder)}>
																		Appointment Date
																	<i className={this._sortClass('appointmentdate')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'appointmentTime', this.state.sortOrder)}>
																		Appointment Time
																	<i className={this._sortClass('appointmenttime')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'appointmentMode', this.state.sortOrder)}>
																		Mode
																	<i className={this._sortClass('appointmentmode')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'avgRate', this.state.sortOrder)}>
																		Feedback Given
																	<i className={this._sortClass('avgrate')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'isDoctorAddedFeedback', this.state.sortOrder)}>
																		Status
																	<i className={this._sortClass('isdoctoraddedfeedback')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'isDoctorAddedFeedback', this.state.sortOrder)}>
																		Action
																</th>
																	{/* <th>Action</th> */}
																</tr>
															</thead>
															<tbody>{
																(myFeedback && myFeedback.length > 0) ?
																	myFeedback.map((item, index) => <tr key={index} >

																		<td >
																			{/* {item.patientDetail[0].profileImage == constant.DEFAULT_USER_IMAGE ?  */}
																			<img style={{ width: 50, height: 45, borderRadius: '50%' }} src={item.userGender == 'Male' ?
																			constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'patient_m.png'
																			: constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'patient_f.png'}
																			alt="User profile picture" /> 
																			{/* : <img style={{ width: 50, height: 45, borderRadius: '50%' }} src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + item.patientId + '/' + item.patientDetail[0].profileImage} alt="User profile picture" />} */}
																		</td>
																		<td className="text-capitalize"><Link>
																			<span className="tooltip-custom fadeEffect tisymtomhover" data-title="View feedback">

																				<a data-tip data-for={'global1' + index} style={{ 'cursor': 'pointer', color: "#00b5e8" }} onClick={this.OpenRateDetail.bind(this, item)} >	{item.patientDetail ? item.patientDetail[0].userName : ''}</a>
																			</span>
																			{/* <ReactTooltip id={'global1' + index} effect='solid'>
																			<p>View feedback</p>
																		</ReactTooltip> */}
																		</Link></td>
																		<td>
																			<Moment format="DD-MM-YYYY">{item.appointmentDate}</Moment>
																		</td>
																		<td >
																			{moment.parseZone(new Date(item.appointmentDate)).format('hh:mm A') + " " + userlocation}
																		</td>
																		<td>
																			{item.appointmentMode == "1" ? 'F2F' : 'Online'}

																		</td>
																		<td  >
																			<StarRatingComponent
																				name="rate2"
																				editing={false}
																				starCount={5}
																				emptyStarColor={'#D3D3D3'}
																				renderStarIcon={(index, value) => {
																					return (
																						<span className="startIcon">
																							{index <= value ? <img src={require('../../images/start_icon.png')} /> : <img src={require('../../images/start_icon_off.png')} />}
																						</span>
																					);
																				}}
																				value={Math.round(item.avgRate)}
																			/>
																		</td>
																		<td>
																			{(item.hasOwnProperty('isDoctorAddedFeedback') && item.isDoctorAddedFeedback == true) ? <span style={{ 'color': 'red' }}>Closed</span> : <span style={{ 'color': 'green' }}>Active</span>}
																		</td>
																		<td>

																			{/* <img className="tooltip-custom fadeEffect tisymtomhover" data-title="Documents" src={require('../../images/img/book.png')} style={{ 'cursor': 'pointer' }}  /> */}
																			<div><Link href="#" className="tooltip-custom fadeEffect tisymtomhover cancelRightTooltip" data-title="View Feedback" onClick={this.OpenRateDetail.bind(this, item)}><img src={require('../../images/img/book.png')} style={{ 'cursor': 'pointer' }} /></Link></div>
																			{this.state.docModal ? <AppointmentDocs openModal={this.state.docModal} hideConditionModal={this.hidedocModal} appointmentId={this.state.appointmentId} patientId={this.state.patientId} /> : ''}

																		</td>
																		{/* <td>
																	<a data-tip data-for={'global1' + index} style={{ fontSize: 18, 'cursor': 'pointer' }} onClick={this.OpenRateDetail.bind(this, item)} ><i style={{ color: "#ff7245" }} className="fa fa-eye" aria-hidden="true"></i></a>
																	<ReactTooltip id={'global1' + index} effect='solid'>
																		<p>View feedback</p>
																	</ReactTooltip>
																</td> */}
																	</tr>)
																	: < tr > <td colSpan={8}><p className="text-center noUpcomingTable">No Feedback Yet ! </p></td></tr>
															}</tbody>
														</table>
													</div></div>
											</div>
										</div>
									</div>
								</div>
								{(myFeedback && myFeedback.length > 0) ?
									<div className="row" style={{ 'marginTop': 30 }}>
										<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
										<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
											<Pagination
												prevPageText='Prev'
												nextPageText='Next'
												hideFirstLastPages
												activePage={this.state.activePage}
												itemsCountPerPage={size}
												pageRangeDisplayed={size}
												totalItemsCount={this.state.totalCount}
												onChange={this.handlePageChange.bind(this)}
											/>

										</div>
									</div> : ''}

							</div>
						</div>
						{this.state.isRateModalOpen == true ? <FeedbackDetail openModal={this.state.isRateModalOpen} closeModal={this.closeRateModal}
							callListAgain={this.closeRateModalNCallList.bind(this)}
							appId={this.state.appointmentId} pId={this.state.patientId} patientDetail={this.state.patientDetail} appDate={this.state.appointmentDate} appTime={this.state.appointmentTime} avgRating={this.state.avgRate} /> : ''}
					</section>

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		myFeedback: state.specialist.myFeedback,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)


	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MyFeedback);
